import { Flex, Text } from '@mantine/core';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { PublicSigningHeader } from './PublicSigningHeader';
import { StatusScreen } from './PublicSigningPage.styles';

/**
 * Shown when a valid programme link resolves to no signable documents — the admin
 * withdrew the request. Not an error: the link itself is fine, there is simply
 * nothing left for this signatory to do.
 */
export const ProgrammeSigningCancelledScreen = () => {
	const tMipManage = useTranslationMipManage();

	return (
		<Flex direction="column" h="100vh">
			<PublicSigningHeader />
			<StatusScreen direction="column" align="center" justify="center" gap="md">
				<Icon variant="information" size="3xl" />
				<Text fw={600} size="xl">
					{tMipManage('documents_page.programme_signing.cancelled_title')}
				</Text>
				<Text c="dimmed" ta="center" maw="32rem">
					{tMipManage('documents_page.programme_signing.cancelled_description')}
				</Text>
			</StatusScreen>
		</Flex>
	);
};
